import React from 'react';
import { cn } from "../../lib/utils";

interface TableContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const TableContainer = React.forwardRef<HTMLDivElement, TableContainerProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div 
        ref={ref}
        className={cn(
          "overflow-x-auto w-full rounded-md mb-4", 
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

TableContainer.displayName = 'TableContainer';

export { TableContainer };